import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ApiError } from "go-core/api/types";
import { SubscriptionInvoiceApi } from "../../../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { selectOrganization } from "../../../../../../../../../../services/organizations/selectors";
import ProformaPreview from "../../components/ProformaPreview";

interface MatchParams {
	proforma_id: string;
}

interface RouteProps {
	match: any;
	loc: Record<string, any>;
	setErrors: (errors: ApiError[]) => void;
	setObservedInvoice: (invoice: string) => void;
	setStartCheckingPaymentStatus: (value: boolean) => void;
	fetchInvoices: () => Promise<SubscriptionInvoiceApi[] | undefined>;
	cardPaymentInProgress: boolean;
	closePreview: () => void;
	loadingItems?: boolean;
}

const OrganizationInvoicesInvoicePreviewPage = (props: RouteProps) => {
	const history = useHistory();
	const { proforma_id } = useParams<MatchParams>();
	const search = Object.keys(props.loc)
		.filter((f) => f !== "include")
		.map((key) => (key === "c" ? `${key}=${encodeURIComponent(`${props.loc[key]}`)}` : `${key}=${props.loc[key]}`))
		.join("&");
	const organization = useSelector(selectOrganization);

	return (
		<ProformaPreview
			proformaId={proforma_id}
			styles={{ zIndex: 99999 }}
			setErrors={props.setErrors}
			onClose={() => history.push(`/${organization.id}/subscriptions/invoices${search ? `?${search}` : ""}`)}
			setObservedInvoice={props.setObservedInvoice}
			setStartCheckingPaymentStatus={props.setStartCheckingPaymentStatus}
			fetchInvoices={props.fetchInvoices}
			cardPaymentInProgress={props.cardPaymentInProgress}
			loadingItems={props.loadingItems}
			closePreview={props.closePreview}
		/>
	);
};

export default OrganizationInvoicesInvoicePreviewPage;
